// The reader's operating system (decision 137): the companion ships for
// Windows, macOS and Linux, and a download button offers the installer of
// the system the page is read on, the other two beside it. The prerender
// knows no system and says Windows; the browser corrects it after the first
// paint, so the markup it hydrates is the one the prerender wrote.

import { useEffect, useState } from "react";

export type Platform = "windows" | "macos" | "linux";

export const PLATFORMS: Platform[] = ["windows", "macos", "linux"];

/** The system a browser says it runs on; Windows when it says nothing we know. */
export function platformOf(userAgent: string): Platform {
  if (/Mac OS X|Macintosh/i.test(userAgent) && !/iPhone|iPad/i.test(userAgent)) return "macos";
  if (/Linux|X11|CrOS/i.test(userAgent) && !/Android/i.test(userAgent)) return "linux";
  return "windows";
}

export function detectPlatform(): Platform {
  return typeof navigator === "undefined" ? "windows" : platformOf(navigator.userAgent);
}

/** The installer of a platform, as the platform's releases route names it. */
export function companionFile(platform: Platform): "companion.msi" | "companion.dmg" | "companion.AppImage" {
  return platform === "macos" ? "companion.dmg" : platform === "linux" ? "companion.AppImage" : "companion.msi";
}

export function platformName(platform: Platform): string {
  return platform === "macos" ? "macOS" : platform === "linux" ? "Linux" : "Windows";
}

/** The reader's platform: Windows at first, the real one once the page runs. */
export function usePlatform(): Platform {
  const [platform, setPlatform] = useState<Platform>("windows");
  useEffect(() => {
    setPlatform(detectPlatform());
  }, []);
  return platform;
}
